export interface DiaryEntry {
  id: string;
  html: string;
  mood: number | null; // 0-4 matching mood picker
  createdAt: number;   // Unix ms timestamp
}

const ENTRIES_KEY = 'koda_diary_entries';

function entriesKey(petId?: string | null): string {
  return petId ? `${ENTRIES_KEY}_${petId}` : ENTRIES_KEY;
}

export function loadDiaryEntries(petId?: string | null): DiaryEntry[] {
  try {
    const raw = localStorage.getItem(entriesKey(petId));
    if (raw) return JSON.parse(raw) as DiaryEntry[];
    return [];
  } catch {
    return [];
  }
}

export function addDiaryEntry(
  html: string,
  mood: number | null,
  petId?: string | null,
): DiaryEntry[] {
  const entries = loadDiaryEntries(petId);
  const newEntry: DiaryEntry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    html,
    mood,
    createdAt: Date.now(),
  };
  const updated = [newEntry, ...entries]; // newest first
  localStorage.setItem(entriesKey(petId), JSON.stringify(updated));
  return updated;
}

export function deleteDiaryEntry(id: string, petId?: string | null): DiaryEntry[] {
  const entries = loadDiaryEntries(petId);
  const updated = entries.filter(e => e.id !== id);
  localStorage.setItem(entriesKey(petId), JSON.stringify(updated));
  return updated;
}

// ── Legacy single-string API (kept for MedicalCard compatibility) ─────────────
export const DIARY_KEY = 'koda_health_diary';
export function loadDiary(petId?: string | null): string {
  return localStorage.getItem(petId ? `${DIARY_KEY}_${petId}` : DIARY_KEY) ?? '';
}
export function saveDiary(html: string, petId?: string | null): void {
  localStorage.setItem(petId ? `${DIARY_KEY}_${petId}` : DIARY_KEY, html);
}
